import React from "react";
import cozyAir from "assets/images/landingAir/hero/cozy-air/cozy-air-lg.jpg";
import cozyAirSm from "assets/images/landingAir/hero/cozy-air/cozy-air-sm.jpg";
import ImageLoader from "../../common/ImageLoader";
import { SUPPORTED_REGIONS } from "../../../../shared/enums";

function CozyAirSlide() {
  return (
    <div className="hero-item hero-item--immersive-slide">
      <ImageLoader
        className="hero-item__image img-relative"
        placeholderAspectRatio={1320 / 617}
        image={cozyAir}
        smallImage={cozyAirSm}
        alt="Mila Black"
        noLazyLoad
      />

      <div className="hero-item__body">
        <div className="hero-item__content">
        <strong className="hero-item__subtitle hero-item__subtitle--cozy-air">FALL is in the air</strong>
          <h1 className="hero-item__title">Welcome to your cozy-air era</h1>
          <h2 className="hero-item__description">
          Sweater weather looks good on you. Fresh air feels even better.
          </h2>
        </div>
        <a
          className="hero-item__button button button--white"
          href="https://buy.milacares.com/"
        >
          Order Now
        </a>
      </div>
    </div>
  );
}

export default CozyAirSlide;
